import { render, staticRenderFns } from "./mgmtPermission.vue?vue&type=template&id=1d0770a0&lang=html"
import script from "./mgmtPermission.vue?vue&type=script&lang=js"
export * from "./mgmtPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports